import {  PATCH } from "../../helper/collaticaRestFunctions";



export const updateUserProfile = async (userId: any, data: any) => {
  const path = `/users/${userId}`;
  return await PATCH({ apiUri: path, data })
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
